var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Chart',{on:{"getData":_vm.getData},scopedSlots:_vm._u([{key:"v",fn:function(){return [_c('div',{attrs:{"id":"echart_four_two"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }